/**
 * @description
 * Objeto usuarios
 */

export class Users {
    public id:number;
    public login:string;
    public name:string;
    public email:string;
    public cryptedPassword:string;
    public salt:string;
    public createdAt:Date;
    public updatedAt:Date;
    public rememberToken:string;
    public rememberTokenExpiresAt:Date;
    public admin:boolean = true;
  
    constructor() {}
  
}